import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="border-t border-border bg-background pt-16 pb-10">
      <div className="container mx-auto px-4">
        <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <img
              src="/lovable-uploads/5e857869-ad31-4667-aad3-34f78fe224ad.png"
              alt="AuthorPro"
              className="h-10 w-auto mb-5"
            />
            <p className="text-muted-foreground leading-relaxed max-w-sm">
              From blank page to a book that keeps working. AuthorPro helps experts plan, sharpen and
              monetise the book that carries their name.
            </p>
          </div>

          <div>
            <h4 className="eyebrow mb-4">The Journey</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/write-your-book" className="text-muted-foreground hover:text-gold transition-colors">Write Your Book</Link></li>
              <li><Link to="/first-draft" className="text-muted-foreground hover:text-gold transition-colors">Manuscript Review</Link></li>
              <li><Link to="/extend" className="text-muted-foreground hover:text-gold transition-colors">Extend</Link></li>
              <li><Link to="/pricing" className="text-muted-foreground hover:text-gold transition-colors">Pricing</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="eyebrow mb-4">Company</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/publishers" className="text-muted-foreground hover:text-gold transition-colors">Publishers</Link></li>
              <li><Link to="/events" className="text-muted-foreground hover:text-gold transition-colors">Events</Link></li>
              <li><Link to="/demo" className="text-muted-foreground hover:text-gold transition-colors">See It in Action</Link></li>
              <li><a href="/#case-studies" className="text-muted-foreground hover:text-gold transition-colors">Case Studies</a></li>
            </ul>
          </div>

          <div>
            <h4 className="eyebrow mb-4">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="mailto:info@series-a.co.uk" className="text-muted-foreground hover:text-gold transition-colors">
                  info@series-a.co.uk
                </a>
              </li>
              <li>
                <a
                  href="https://meetings.series-a.co/meetings/series-a/authorpro"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted-foreground hover:text-gold transition-colors"
                >
                  Book a discovery call
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} AuthorPro.ai. All rights reserved.
          </p>
          <div className="flex flex-wrap justify-center gap-6 text-xs">
            <Link to="/privacy-policy" className="text-muted-foreground hover:text-gold transition-colors">Privacy Policy</Link>
            <Link to="/terms-of-service" className="text-muted-foreground hover:text-gold transition-colors">Terms of Service</Link>
            <Link to="/cookie-policy" className="text-muted-foreground hover:text-gold transition-colors">Cookie Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
